import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { cashOutline, printOutline, saveOutline, trashOutline } from 'ionicons/icons';
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import Select from 'react-select';
import { statusDropDownStyles } from '@ui/styles/status-dropdown-style';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { IonIcon } from '@ionic/react';
import InfoTab from './info/InfoTab';
import NotesTab from './note/NotesTab';
import PurchaseInvoiceTabsHelpers from './purchaseInvoiceHelpers';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { CreatePurchaseInvoiceAsync, UpdatePurchaseInvoiceAsync, deletePurchaseInvoiceByIdAsync, getAllPurchaseInvoiceStatusAsync, getPurchaseInvoiceByIdAsync } from '@application/features/purchaseInvoices/purchaseInvoiceThunk';
import { useEffect, useState } from 'react';
import PurchaseInvoiceLineTab from './purchaseInvoiceLine/PurchaseInvoiceLineTab';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import ModalPopup from '@ui/components/VnModal';
import PurchaseInvoicePrintPreview from './PurchaseInvoicePrintPreview';
import { PurchaseInvoiceStatus } from '@application/common/enums/purchase-invoice-status';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { setOrderNumberForPurchaseInvoice, setSelectedCalculationForPurchaseInovice } from '@application/features/orders/orderSlice';
import { TabNotification } from '@ui/components/VnTabNotification';
import { clearUpdateModulePermissionStatus, resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { useAsyncDebounce } from '@application/common/hooks/use-async-debounce';
import PersistentWarningMessage from '@ui/components/VnNotification/PersistantWarningMessage';
import PersistentInfoMessage from '@ui/components/VnNotification/PersistantInfoMessage';
import { addErrorNotification } from '@application/features/common/notificationSlice';
const PurchaseInvoiceView = () => {
    const { formdata, setFormData, errors, handleFieldChange, handleCalendarChange, validateForm, handleUploadAttachmentChange, infoTabErrorBorderColor, isNotesTabUnsaved, isInfoTabUnsaved, isInfoTabBold, isNotesTabBold } = PurchaseInvoiceTabsHelpers();
    const { purchaseInvoiceStatusDropdown } = useAppSelector((state) => state.purchaseinvoice);
    const { id } = useParams();
    const [submitPurchaseInvoice, setSubmitPurchaseInvoice] = useState(false);
    const [isPurchaseInvoiceDeleteConfirmationPopup, setPurchaseInvoiceDeleteConfirmationPopup] = useState(false);
    VnDocumentTitle('Visser InkoopFac-' + formdata.purchaseInvoiceNumber);
    const [isPurchaseInvoicePrintPreviewOpen, setPurchaseInvoicePrintPreviewOpen] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [purchaseInvoiceDisableField, setPurchaseInvoiceDisableField] = useState(false);
    const [purchaseInvoicePrintData, setPurchaseInvoicePrintData] = useState(formdata);
    const { moduleLocked, updateModulePermissionStatus } = useAppSelector((state) => state.workorder);
    const [isPurchaseInvoiceLineTabBold, setIsPurchaseInvoiceLineTabBold] = useState(false);
    useEffect(() => {
        dispatch(getAllPurchaseInvoiceStatusAsync());
    }, []);
    useEffect(() => {
        if (id) {
            dispatch(setOrderNumberForPurchaseInvoice(null));
            dispatch(getPurchaseInvoiceByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData(res);
                setPurchaseInvoicePrintData(res);
                if (res.statusId == PurchaseInvoiceStatus.Geaccordeerd) {
                    setPurchaseInvoiceDisableField(true);
                }
            })
                .catch((error) => {
                navigate(`/admin/PurchaseInvoiceList`);
                console.error('Bad request.');
            });
        }
    }, [id]);
    const handleStatusDropdownChange = (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            statusId: selectedOption.value
        }));
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitPurchaseInvoice) {
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                const triggeredErrors = validateForm();
                if (Object.values(triggeredErrors).every((error) => !error)) {
                    if (!id) {
                        dispatch(CreatePurchaseInvoiceAsync(formdata))
                            .unwrap()
                            .then((res) => {
                            navigate(`/admin/PurchaseInvoicesTabs/${res.id}`);
                            setFormData(res);
                        })
                            .catch((error) => { });
                    }
                    else {
                        dispatch(UpdatePurchaseInvoiceAsync(formdata))
                            .unwrap()
                            .then((res) => {
                            dispatch(getPurchaseInvoiceByIdAsync(parseInt(id)))
                                .unwrap()
                                .then((res) => {
                                setFormData(res);
                                setPurchaseInvoicePrintData(res);
                                if (res.statusId == PurchaseInvoiceStatus.Geaccordeerd) {
                                    setPurchaseInvoiceDisableField(true);
                                }
                            });
                        })
                            .catch((error) => { });
                    }
                }
                setSubmitPurchaseInvoice(false);
            }
        }
    };
    const handlePurchaseInvoiceDelete = () => {
        if (id) {
            dispatch(deletePurchaseInvoiceByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/PurchaseInvoiceList'))
                .catch((error) => {
                setPurchaseInvoiceDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelPurchaseInvoiceDeleteClicked = () => {
        setPurchaseInvoiceDeleteConfirmationPopup(false);
    };
    //-------------------------Module Lock Functionality-------------------//
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Inkoopfacturen,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    const checkModulelockandTimeTriggerForFields = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            // Return false immediately to allow the user to continue working
            var result = false;
            // Call the debounced API function
            debouncedCheckModuleLockApiCall()
                .then((res) => {
                if (res.isModuleAlreadyLocked) {
                    // Notify the user if the module is locked
                    // setIsPersistantInfoCustomToasterOpen(res.isModuleAlreadyLocked);
                    dispatch(setModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
                else {
                    dispatch(unsetModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
            })
                .catch(() => {
                dispatch(unsetModuleLock());
                // Handle any errors if needed
            });
            return result; // Allow user to continue working immediately
        }
        return false;
    };
    const checkModuleLockApiCall = async () => {
        const moduleLockRequestData = {
            moduleId: VisserModule.Inkoopfacturen,
            recordId: formdata.id
        };
        return await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
    };
    const debouncedCheckModuleLockApiCall = useAsyncDebounce(checkModuleLockApiCall, parseInt(process.env.REACT_APP_DEBOUNCE_TIME_FOR_MODULE_LOCK_API));
    useEffect(() => {
        // Cleanup function that runs when the component unmounts
        return () => {
            dispatch(resetTimer());
            dispatch(unsetModuleLock());
            dispatch(clearUpdateModulePermissionStatus());
        };
    }, [resetTimer]);
    useEffect(() => {
        dispatch(unsetModuleLock());
        // checkModulelock();
    }, []);
    const handleFieldChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        if (moduleLockStatus == false) {
            handleFieldChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleFieldChangeWrapperForText = async (fieldName, value) => {
        handleFieldChange(fieldName, value); // Call the original handleFieldChange
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        // if (moduleLockStatus == false) {
        //     handleFieldChange(fieldName, value); // Call the original handleFieldChange
        // }
    };
    const handleCalendarChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleCalendarChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleUploadAttachmentChangeWrapper = async (fieldName, value) => {
        if (value != null) {
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                handleUploadAttachmentChange(fieldName, value);
            }
        }
    };
    const handlePurchaseInvoiceLineTabBold = (state) => {
        setIsPurchaseInvoiceLineTabBold(state);
    };
    const handlePurchaseInvoiceOnModuleLockReset = (value) => {
        if (value) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((error) => !error)) {
                dispatch(UpdatePurchaseInvoiceAsync(formdata));
            }
        }
    };
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const dataKey = searchParams.get('dataKey');
        if (dataKey) {
            try {
                const storedData = localStorage.getItem(dataKey);
                if (storedData) {
                    const { orderData, calculations } = JSON.parse(storedData);
                    handleFieldChange('orderId', orderData.value.toString());
                    handleFieldChange('orderNumber', orderData.label);
                    // dispatch(getOrdersListAsync(orderData.label ?? ''))
                    // .unwrap()
                    // .then((res) => {
                    //     handleFieldChange('supplierId', res[0].supplierId.toString());
                    // });
                    dispatch(setOrderNumberForPurchaseInvoice(orderData));
                    dispatch(setSelectedCalculationForPurchaseInovice(calculations));
                    localStorage.removeItem(dataKey);
                    //   onFieldChange('orderId', OrderNumberForPurchaseInvoice.value.toString());
                    //             onFieldChange('orderNumber', OrderNumberForPurchaseInvoice.label);
                    // dispatch(getOrdersListAsync(orderData.label ?? ''))
                    //     .unwrap()
                    //     .then((res) => {
                    //         handleFieldChange('supplierId', res[0].supplierId.toString());
                    //     });
                }
            }
            catch (error) {
                console.error('Error loading purchase invoice data:', error);
                dispatch(addErrorNotification('Ongeldige inkoopfactuurgegevens'));
            }
        }
    }, [searchParams, dispatch]);
    //  useEffect(() => {
    //             const dataKey = searchParams.get('dataKey');
    //             if (dataKey) {
    //               const savedData = localStorage.getItem(dataKey);
    //               if (savedData) {
    //                 const { workOrderId, workOrderNumber, calculations } = JSON.parse(savedData);
    //                 // Dispatch necessary actions
    //                 dispatch(setWorkOrderNumber({ label: workOrderNumber, value: workOrderId }));
    //                 dispatch(setSelectedWorkorderCalculationItemsList(calculations));
    //                 handleFieldChange("workOrderId",workOrderId)
    //                 handleFieldChange("workorderNumber",workOrderNumber)
    //                 // Cleanup storage
    //                 //localStorage.removeItem(dataKey);
    //               }
    //             }
    //     }, [dispatch, searchParams]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'mt-1', children: [_jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Inkoopfacturen" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/PurchaseInvoiceList', children: [_jsx("span", { children: _jsx(IonIcon, { icon: cashOutline, className: 'vn-breadcrum-icon cash-icon-flipped' }) }), "Inkoopfacturen"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formdata.purchaseInvoiceNumber })] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', type: 'button', customIconClassName: 'vn-action-button-icon', onClick: async () => {
                                                    var moduleLockStatus = await checkModulelock();
                                                    if (moduleLockStatus == false) {
                                                        setPurchaseInvoiceDeleteConfirmationPopup(true);
                                                    }
                                                }, isDisabled: moduleLocked || (!handleRolePermission(Permission.INKOOPFACTUREN, PermissionType.Delete) ||
                                                    !id ||
                                                    purchaseInvoiceDisableField !== false) }), _jsx(VnButton, { icon: printOutline, customClassName: 'vn-action-button-cancel', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon', onClick: () => {
                                                    setPurchaseInvoicePrintPreviewOpen(true);
                                                }, isDisabled: moduleLocked || !id, type: 'button' }), formdata.id ? (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                    setSubmitPurchaseInvoice(true);
                                                }, customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked || (!handleRolePermission(Permission.INKOOPFACTUREN, PermissionType.Update) ||
                                                    purchaseInvoiceDisableField) })) : (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                    setSubmitPurchaseInvoice(true);
                                                }, customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked || (!handleRolePermission(Permission.INKOOPFACTUREN, PermissionType.Create) ||
                                                    purchaseInvoiceDisableField
                                                    ? true
                                                    : false) }))] })] }), _jsx("div", { className: 'vn-Status-Container', children: _jsxs("div", { style: { display: 'flex' }, children: [_jsx("label", { className: 'vn-status-label', children: "Status:" }), _jsx(Select, { styles: statusDropDownStyles, value: purchaseInvoiceStatusDropdown?.find((option) => option.value === formdata.statusId), options: purchaseInvoiceStatusDropdown, isSearchable: false, onChange: handleStatusDropdownChange, isDisabled: purchaseInvoiceDisableField })] }) }), _jsxs(Tabs, { className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `${infoTabErrorBorderColor ? 'has-errors' : ''}
                             ${isInfoTabBold ? 'has-data' : ''}`, children: _jsx(InfoTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleFieldChangeWrapper, onUploadAttachmentFieldChange: handleUploadAttachmentChangeWrapper, isPurchaseInvoiceDisable: purchaseInvoiceDisableField }) }), _jsx(Tab, { eventKey: 'PurchaseInvoiceLineTab', title: 'Inkoopfactuurregels', tabClassName: `${isPurchaseInvoiceLineTabBold ? 'has-data' : ''}`, children: _jsx(PurchaseInvoiceLineTab, { formData: formdata, onFieldChange: handleFieldChangeWrapperForText, isPurchaseInvoiceDisable: purchaseInvoiceDisableField, isPurchaseInvoiceLineTabBold: handlePurchaseInvoiceLineTabBold }) }), _jsx(Tab, { eventKey: 'NotesTab', title: TabNotification('Notities', false, isNotesTabUnsaved), tabClassName: `${isNotesTabBold ? 'has-data' : ''}`, children: _jsx(NotesTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, onUploadAttachmentFieldChange: handleUploadAttachmentChangeWrapper, isPurchaseInvoiceDisable: purchaseInvoiceDisableField }) })] })] }), _jsx(VnConfirmationModel, { title: 'Alle tabbladgegevens van de inkoopfacturen worden permanent verwijderd. Weet u zeker dat u de inkoopfactuur wilt verwijderen?', onCancel: () => onCancelPurchaseInvoiceDeleteClicked(), onConfirm: () => handlePurchaseInvoiceDelete(), onOpen: isPurchaseInvoiceDeleteConfirmationPopup }), _jsx(ModalPopup, { title: 'Inkoopfactuur', content: _jsx(PurchaseInvoicePrintPreview, { onClose: () => setPurchaseInvoicePrintPreviewOpen(false), purchaseInvoicePrintData: purchaseInvoicePrintData }), onOpen: isPurchaseInvoicePrintPreviewOpen, onClose: () => setPurchaseInvoicePrintPreviewOpen(false), modalWidth: 'xl' })] }), updateModulePermissionStatus && !moduleLocked ? (_jsx(PersistentWarningMessage, { recordId: formdata.id, moduleId: VisserModule.Inkoopfacturen, handleIsModuleLockReset: handlePurchaseInvoiceOnModuleLockReset })) : (''), moduleLocked ? _jsx(PersistentInfoMessage, { recordId: formdata.id, moduleId: VisserModule.Inkoopfacturen }) : ''] }));
};
export default PurchaseInvoiceView;
